import ProPage from "./container";

export default ProPage;